export function sortByOrder(items = []) {
    return [...items]
        .map((item, index) => ({ item, index }))
        .sort((a, b) => {
            const orderDiff = getItemOrder(a.item, a.index) - getItemOrder(b.item, b.index);
            return orderDiff !== 0 ? orderDiff : a.index - b.index;
        })
        .map(({ item }) => item);
}

export function toExamBankItemDtos(items = []) {
    return sortByOrder(items).map((item) => ({
        id: item.id,
        order: item.order ?? 0,
    }));
}

export function getNextOrder(items = []) {
    if (!items.length) return 0;
    return Math.max(...items.map((item) => item.order ?? 0)) + 1;
}

export function validateOrderedItems(items, labels) {
    const { idLabel, orderLabel } = labels;
    const ids = items.map((item) => item.id);
    const orders = items.map((item) => item.order ?? 0);

    if (orders.some((order) => !Number.isInteger(order) || order < 0)) {
        return `ترتیب باید عدد صحیح غیرمنفی برای ${orderLabel} باشد.`;
    }

    if (new Set(ids).size !== ids.length) {
        return `شناسه‌های تکراری برای ${idLabel} مجاز نیست.`;
    }

    if (new Set(orders).size !== orders.length) {
        return `مقادیر ترتیب تکراری برای ${orderLabel} مجاز نیست.`;
    }

    return null;
}

export function normalizeBankItemOrder(item, index = 0) {
    if (typeof item === "string") {
        return { id: item, order: index };
    }

    const id = item?.id ?? item?.Id ?? item;
    return {
        ...item,
        id,
        order: item?.order ?? item?.Order ?? index,
    };
}

export function getItemOrder(item, fallbackIndex = 0) {
    if (typeof item === "string") return fallbackIndex;
    return item?.order ?? item?.Order ?? fallbackIndex;
}
